<template>
  <div class="content" id="test">
    <van-nav-bar
      :placeholder="true"
      :fixed="true"
      left-arrow
      @click-left="$router.go(-1)"
    >
      <template #right>
        <van-icon @click="showShare = true" name="share-o" />
      </template>
    </van-nav-bar>

    <div class="article">
      <h3 style="text-align:center">{{ list.title }}</h3>
      <div class="author">
        <p style="">
          <img src="" alt="" /> <span>{{ list.author }}</span>
        </p>
        <p class="addTime">{{ time }}</p>
      </div>
      <div class="box" ref="box" v-html="list.content"></div>
      <div class="evaluate">
        <p></p>
        <p class="p2">
          <span><van-icon name="eye" size="0.6rem" />{{ list.hit }}</span>
          <span>
            <van-icon
              :name="isLike == 1 ? 'good-job' : 'good-job-o'"
              :color="isLike == 1 ? '#FFE339' : ''"
              size="0.6rem"
              @click="getLike()"
            />{{ list.likeCounts }}</span
          >
        </p>
      </div>
    </div>
    <van-share-sheet
      v-model="showShare"
      title="立即分享给好友"
      :options="options"
      @select="onSelect"
    />
  </div>
</template>
<script>
import checkDevice from "../../tools/app";
export default {
  data() {
    return {
      id: this.$route.params.id,
      id2: this.$route.query.id2,
      list: [],
      isLike: "",
      userId: "",
      time: "",
      showShare: false,
      options: [
        { name: "微信", icon: "wechat" },
        { name: "朋友圈", icon: "wechat-moments" },
        { name: "复制链接", icon: "link" },
      ],
      list2: [],
    };
  },
  created() {
    window["callJsFunction"] = this.callJsFunction;
    this.getList();
  },
  mounted() {
    this.getActivityClass();
  },
  methods: {
    //  请求数据
    getList() {
      this.$post({
        url: "owsHomePage/homePageDetailById/" + this.id,
        method: "get",
        params: {
          userId: this.userId,
        },
      })
        .then((res) => {
          if (res.retCode == 200) {
            this.list = res.data.code;
            this.isLike = this.list.isLike;
            let date = new Date(res.data.code.is_add_time);
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            let day = date.getDate();
            this.time = `${year}-${month}-${day}`;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //  点赞
    getLike() {
      this.$post({
        url: "owsHomePage/isLike",
        method: "post",
        params: {
          articleId: this.list.article_id,
          userId: this.userId,
        },
      })
        .then((res) => {
          if (res.data.retCode == 800201) {
            this.isLike = 1;
            this.list.likeCounts++;
            this.$toast(res.data.message);
          } else {
            this.isLike = 0;
            this.list.likeCounts--;
            this.$toast(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getActivityClass() {
      await this.$post({
        url: "/AppDiscovery/getDiscoveryById",
        method: "get",
        params: {
          id: this.id2,
        },
      })
        .then((res) => {
          if (res.retCode == 200) {
            this.list2 = res.data.data;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    onSelect(option) {
      let phone = checkDevice();
      // 判断设备系统的函数
      if (phone == "ios") {
        if (option.name == "微信") {
          // IOS系统并且选择的是微信支付
          window.webkit.messageHandlers.jsCallOCFunction2.postMessage([
            this.list2,
            "1",
          ]);
        } else if (option.name == "朋友圈") {
          // IOS系统并且选择的是支付宝支付
          window.webkit.messageHandlers.jsCallOCFunction2.postMessage([
            this.list2,
            "2",
          ]);
        } else if (option.name == "复制链接") {
          window.webkit.messageHandlers.jsCallOCFunction2.postMessage([
            this.list2,
            "3",
          ]);
         
        } else {
          this.$toast.fail("未安装微信");
          return false;
        }
      } else if (phone == "android") {
        if (option.name == "微信") {
          // Android系统并且选择的是微信支付
          window.jsCallAndroid.jsCallOCFunction([
            JSON.stringify(this.list2),
            "1",
          ]);
        } else if (option.name == "朋友圈") {
          // Android系统并且选择的是支付宝支付
          window.jsCallAndroid.jsCallOCFunction([
            JSON.stringify(this.list2),
            "2",
          ]);
        } else if (option.name == "复制链接") {
          window.jsCallAndroid.jsCallOCFunction([
            JSON.stringify(this.list2),
            "3",
          ]);
        } else {
          this.$toast.fail("未选择支付方式");
          return false;
        }
      } else {
        this.$toast.fail("未安装微信");
        return false;
      }
      this.showShare = false;
    },
  },
};
</script>

<style lang="less" scoped>
.van-nav-bar {
  margin-top: 0;
  padding-top: constant(safe-area-inset-top); /* 兼容旧的iOS版本 */

  @supports (padding-top: env(safe-area-inset-top)) {
    padding-top: env(safe-area-inset-top); /* 只有支持env()的浏览器会应用这个 */
  }
}
.content {
  .video {
    padding: 0.2667rem;
    text-align: center;
    background-color: white;
  }
  .article {
    background-color: white;
    padding: 0.4rem 0.4rem 1rem 0.4rem;
    .author {
      margin-top: 0.4667rem;
      font-family: PingFang SC;
      font-weight: 600;
      color: #333;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .addTime {
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 0.3733rem;
        color: #999999;
      }
    }
  }
  .box {
    overflow: hidden;
    /deep/img {
      display: block;
      margin: 0 auto;  
      max-width: 100% !important;
      margin: 0.2125rem 0;
      border-radius: 0.3125rem;
    }
  }
  .evaluate {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 0.4rem;
    // padding: 0 0.5333rem;
    .p2 {
      display: flex;
      align-items: center;
      font-size: 0.48rem;
      span {
        margin-left: 0.4rem;
        display: flex;
        align-items: center;
      }
      i {
        margin-right: 0.1333rem;
      }
    }
  }
  .shop {
    margin-top: 0.2667rem;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.4533rem;
    .shop-top {
      margin-right: 2.3rem;
      .p1 {
        font-weight: 600;
        color: #333;
      }
      .p2 {
        margin-top: 0.4rem;
        font-weight: 500;
        color: #f5492c;
      }
    }
    img {
      width: 1.8667rem;
      height: auto;
    }
  }
  /deep/.van-nav-bar .van-icon {
    color: black;
    font-size: 0.75rem;
  }
}
</style>
